/* eslint-disable */
/*
  core-js override for Chrome 38 based older TV's for Symbol.toPrimitive returning the wrong value for a Symbol parameter
  overrides core-js's symbol-define-to-primitive.js
*/

// @ts-nocheck - This polyfill file intentionally bypasses type checking to fix Chrome 38 issues

import defineBuiltIn from 'core-js/internals/define-built-in';
import getBuiltIn from 'core-js/internals/get-built-in';
import wellKnownSymbol from 'core-js/internals/well-known-symbol';

const TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
const TypeError = getBuiltIn('TypeError');

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineBuiltIn(
  getBuiltIn('Symbol').prototype,
  TO_PRIMITIVE,
  function (hint) {
    const symbolValue = this;
    if (typeof symbolValue !== 'symbol') {
      // Fix for Chrome 38: ensure we return the symbol itself instead of undefined
      if (typeof symbolValue === 'string' || typeof symbolValue === 'number') {
        return symbolValue;
      }
      // throw TypeError('Symbol.prototype[Symbol.toPrimitive] called on non-symbol');
    }
    if (typeof symbolValue === 'object') {
      var keys = Object.keys(symbolValue);
      console.error(
        'Symbol.prototype[Symbol.toPrimitive] called on non-symbol:keys: ' +
        keys +
        ' typeof: ' +
        typeof symbolValue +
        ' hint: ' +
        hint,
        symbolValue,
      );
    }

    // Fix for Chrome 38: Handle hint parameter properly
    // According to spec, Symbol.toPrimitive should throw TypeError when called
    // But Chrome 38 has issues with symbol conversion
    if (hint === 'string') {
      // Return the symbol's description or empty string if no description
      return symbolValue.description || '';
    } else if (hint === 'number') {
      // Symbols cannot be converted to numbers, throw TypeError
      throw TypeError('Cannot convert symbol to number');
    }

    // For default hint or no hint, return the symbol's description or empty string
    return symbolValue.description || '';
  },
  { arity: 1, name: 'description' },
);
